export default __webpack_public_path__ + "routing-500-5620cc2ab18bbd36f1ffb205b2868617.webp";